module.exports = __webpack_public_path__ + "img/refresh.bb563d01.svg";